import { render, staticRenderFns } from "./MiniProfileIcon.vue?vue&type=template&id=3c0f98ca"
import script from "./MiniProfileIcon.vue?vue&type=script&lang=ts"
export * from "./MiniProfileIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports